<formstep-detail :options="options" :editable="true" :model="variante"></formstep-detail>